import React, { InputHTMLAttributes } from 'react';
import { useField } from 'formik';

interface CheckboxFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    label: string;
    id?: string;
    isChecked?: boolean;
    error?: boolean;
    helperText?: string;
}

function FormikCheckboxField({ helperText, name, label, id = '', ...rest }: CheckboxFieldProps) {
    const [field, meta] = useField(name);

    return (
        <div className="space-y-1">
            <label className="input-wrap flex gap-2 cursor-pointer" htmlFor={id || name}>
                <input
                    className="rounded-full focus:ring-brand focus:ring-2 text-brand cursor-pointer w-6 h-6"
                    type="checkbox"
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    checked={field.value}
                    name={name}
                    id={id || name}
                    {...rest}
                />
                <span className="ml-2 text-sm leading-tight cursor-pointer">{label}</span>
            </label>
            {helperText && !meta.error && <div className={`pl-4 text-xs text-left text-secondary`}>{helperText}</div>}
            {meta.error && meta.touched && <div className={`pl-4 text-xs text-left text-danger`}>{meta.error}</div>}
        </div>
    );
}

export default FormikCheckboxField;
